// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-35e851be] {\n  font-size: 16px;\n  font-weight: 700;\n  margin-right: 10px;\n}\n.feet-r[data-v-35e851be] {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}", ""]);
// Exports
module.exports = exports;
